const clientSentpaymentDt           = require('./clientSentpayment-dt')
const clientSentpaymentFullcont     = require('./clientSentpayment-fullcont')
const clientSentpaymentMenu         = require('./clientSentpayment-menu')
const clientSentpaymentSnack        = require('./clientSentpayment-snack')
const clientSentpaymentMT           = require('./clientSentpayment-fullcont-multitable')

export function start(detail){  
        
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      dt:              { start: (detail)=>{  clientSentpaymentDt. start(detail)              }},
      fullcont:        { start: (detail)=>{  clientSentpaymentFullcont. start(detail)        }},
      menu:            { start: (detail)=>{  clientSentpaymentMenu.start(detail)             }},
      multitable:      { start: (detail)=>{  clientSentpaymentMT.start(detail)               }},
      snack:           { start: (detail)=>{  clientSentpaymentSnack.start(detail)            }},
}